module.exports = __webpack_public_path__ + "img/school1.fa141757.jpg";